import "./App.css";
import Main from "./Component/Main";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Privacy from "./Component/Privacy";
import ProductDetail from "./Component/ProductDetail";
import CartPage from "./Component/CartPage";
import CheckOut from "./Component/CheckOut";
import { CartProvider } from "./Component/CartContext";
import PaySuccess from "./Component/SuccessPay";
import Terms from "./Component/Terms";
import Shop from "./Component/Shop";
import Contact from "./Component/Contact";
import Returns from "./Component/Returns";
import About from "./Component/About";
import Header from "./Component/Header";
import Footer from "./Component/Footer";
import Delivery from "./Component/Delivery";
import FAQs from "./Component/FAQs";
import CookiePolicy from "./Component/CookiePolicy";
import TermsOfSale from "./Component/TermsOfSale";
import PaymentPolicy from "./Component/PaymentPolicy";
import OrderPolicy from "./Component/OrderPolicy";
import WarrantyPolicy from "./Component/WarrantyPolicy";
import SubscriptionPolicy from "./Component/SubscriptionPolicy";
import PromotionsPolicy from "./Component/PromotionsPolicy";
import FoodSafetyPolicy from "./Component/FoodSafetyPolicy";
import Accessibility from "./Component/Accessibility";
import AcceptableUse from "./Component/AcceptableUse";
import IntellectualProperty from "./Component/IntellectualProperty";
import SecurityPolicy from "./Component/SecurityPolicy";
import Disclaimer from "./Component/Disclaimer";
import LegalNotice from "./Component/LegalNotice";
import PolicyIndex from "./Component/PolicyIndex";

function App() {
  return (
    <CartProvider>
      <Router>
        <Header />
        <Routes>
          <Route path="/about" element={<About />} />
          <Route path="/shipping" element={<Delivery />} />
          <Route path="/" element={<Main />} />
          <Route path="/returns" element={<Returns />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/shop" element={<Shop />} />
          <Route path="/terms" element={<Terms />} />
          <Route path="/terms-of-sale" element={<TermsOfSale />} />
          <Route path="/privacy" element={<Privacy />} />
          <Route path="/faqs" element={<FAQs />} />
          <Route path="/cookies" element={<CookiePolicy />} />
          <Route path="/policies" element={<PolicyIndex />} />
          <Route path="/payment-policy" element={<PaymentPolicy />} />
          <Route path="/order-policy" element={<OrderPolicy />} />
          <Route path="/warranty" element={<WarrantyPolicy />} />
          <Route path="/subscriptions" element={<SubscriptionPolicy />} />
          <Route path="/promotions" element={<PromotionsPolicy />} />
          <Route path="/food-safety" element={<FoodSafetyPolicy />} />
          <Route path="/accessibility" element={<Accessibility />} />
          <Route path="/acceptable-use" element={<AcceptableUse />} />
          <Route path="/intellectual-property" element={<IntellectualProperty />} />
          <Route path="/security" element={<SecurityPolicy />} />
          <Route path="/disclaimer" element={<Disclaimer />} />
          <Route path="/legal-notice" element={<LegalNotice />} />
          <Route path="/shopDetails/:id" element={<ProductDetail />} />
          <Route path="/cartpage" element={<CartPage />} />
          <Route path="/checkout" element={<CheckOut />} />
          <Route path="/paysuccess" element={<PaySuccess />} />
          <Route path="/payment" element={<PaySuccess />} />
        </Routes>
        <Footer />
      </Router>
    </CartProvider>
  );
}

export default App;
